__turbopack_context__.v({
  "btnArea": "login-module-scss-module__rBepBa__btnArea",
  "chk_box": "login-module-scss-module__rBepBa__chk_box",
  "clickbtn": "login-module-scss-module__rBepBa__clickbtn",
  "content": "login-module-scss-module__rBepBa__content",
  "email_logo": "login-module-scss-module__rBepBa__email_logo",
  "etc_btn": "login-module-scss-module__rBepBa__etc_btn",
  "form_box": "login-module-scss-module__rBepBa__form_box",
  "form_box_group": "login-module-scss-module__rBepBa__form_box_group",
  "ico_eye": "login-module-scss-module__rBepBa__ico_eye",
  "id_pw_close": "login-module-scss-module__rBepBa__id_pw_close",
  "id_pw_open": "login-module-scss-module__rBepBa__id_pw_open",
  "inp_certification": "login-module-scss-module__rBepBa__inp_certification",
  "inp_id": "login-module-scss-module__rBepBa__inp_id",
  "inp_pw": "login-module-scss-module__rBepBa__inp_pw",
  "inp_txt": "login-module-scss-module__rBepBa__inp_txt",
  "lang_box": "login-module-scss-module__rBepBa__lang_box",
  "login_box": "login-module-scss-module__rBepBa__login_box",
  "login_box_group": "login-module-scss-module__rBepBa__login_box_group",
  "login_btn": "login-module-scss-module__rBepBa__login_btn",
  "login_footer": "login-module-scss-module__rBepBa__login_footer",
  "login_inp": "login-module-scss-module__rBepBa__login_inp",
  "login_sub_inp": "login-module-scss-module__rBepBa__login_sub_inp",
  "logo": "login-module-scss-module__rBepBa__logo",
  "on": "login-module-scss-module__rBepBa__on",
  "result_box": "login-module-scss-module__rBepBa__result_box",
  "sel_box": "login-module-scss-module__rBepBa__sel_box",
  "sub": "login-module-scss-module__rBepBa__sub",
  "tel2": "login-module-scss-module__rBepBa__tel2",
  "time": "login-module-scss-module__rBepBa__time",
  "txt": "login-module-scss-module__rBepBa__txt",
});
